import React, { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, CardBody, Table, Modal, ModalHeader } from "reactstrap"

import Paginations from "components/Common/Pagination"
import Filters from "components/Shared/Filters"
import Spinners from "components/Shared/Spinners"
import {
  setParticipantsPayload as setPayload,
  resetParticipantsPayload as resetPayload,
} from "store/reducers/theoreticalTrainingReducer"
import {
  deleteTheoreticalTrainingParticipant,
  getTheoreticalTrainingParticipants,
} from "store/actions/theoreticalTrainingAction"
import { getJobTitlesList } from "store/actions/commonAction"
import { Trash } from "lucide-react"
import DeleteModal from "components/Common/DeleteModal"
import { showAlert } from "store/reducers/alertReducer"
import ViewAssessment from "../ViewAssessment"

const CandidateTabs = ({ activeTab }) => {
  const {
    isLoading,
    theoreticalParticipants,
    perPage,
    totalPages,
    totalCount,
    currentPage,
    participantsPayload: payload,
  } = useSelector(state => state.TheoreticalTraining)
  const { jobTitlesList } = useSelector(state => state.Common)

  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()

  const [selectedItem, setSelectedItem] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [trigger, setTrigger] = useState(false)
  const [modal1, setModal1] = useState(false)

  useEffect(() => {
    getAllData()
  }, [activeTab, trigger])

  useEffect(() => {
    dispatch(resetPayload())
  }, [activeTab])

  useEffect(() => {
    dispatch(getJobTitlesList())
  }, [])

  const getAllData = () => {
    let obj = {
      ...payload,
      filters: {
        ...payload.filters,
        type: activeTab,
      },
    }

    dispatch(getTheoreticalTrainingParticipants(obj))
  }

  const onPageChange = page => {
    dispatch(setPayload({ page_number: page }))
    setTrigger(!trigger)
  }
  const handleSearch = () => {
    setTrigger(!trigger)
  }

  useEffect(() => {
    handleReset()
  }, [activeTab])

  const handleReset = () => {
    dispatch(resetPayload())
    setTrigger(!trigger)
  }

  const handleDelete = () => {
    dispatch(deleteTheoreticalTrainingParticipant(selectedItem))
      .then(action => {
        const { statusCode, success, message } = action?.payload

        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setTrigger(!trigger)
          setShowDeleteModal(false)
          setSelectedItem(null)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }
  const formattedJobTitles = useMemo(() => {
    if (!jobTitlesList) return []

    return jobTitlesList.map(jobTitle => ({
      value: jobTitle.id,
      label: jobTitle[language === "en" ? "name" : "name_ar"],
    }))
  }, [jobTitlesList])

  let filters = {
    keyword: {
      type: "text",
      placeholder: t("Search by name,phone or national id"),
      label: t("Search By"),
      colSize: 4,
    },
    job_title_ids: {
      type: "select",
      placeholder: t("Select Job Title"),
      label: t("Job Title"),
      colSize: 4,
      options: formattedJobTitles,
      multiple: true,
    },
  }

  return (
    <>
      {isLoading ? (
        <Spinners />
      ) : (
        <div>
          {/* <div className="g_between mb-3">
            <h4 className="card-title mb-4">{t("Interviews")}</h4>
            <Button
              color="primary"
              onClick={() => {
                setIsShowFilter(!isShowFilter)
              }}
              title={t("Show/Hide Filter")}
            >
              {isShowFilter ? <FilterX /> : <Filter />}
            </Button>
          </div> */}
          {/* {isShowFilter && ( */}
          <Filters
            filters={filters}
            state={{ ...payload.filters, order_by: payload.order_by }}
            setState={data => {
              const { order_by, ...rest } = data

              dispatch(
                setPayload({
                  order_by: Number(order_by),
                  filters: { ...payload.filters, ...rest },
                })
              )
            }}
            handleSearch={handleSearch}
            handleReset={handleReset}
          />
          <Card className="user_personal_info mt-3 theme_card">
            <CardBody>
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead className="table-light full_th">
                    <tr>
                      <th>{t("S. No.")}</th>
                      {/* <th>{t("Total Capacity")}</th>
                                <th>{t("Total User Enrolled")}</th>
                                <th>{t("Total Available Seat")}</th> */}
                      <th>{t("Name")}</th>
                      <th>{t("National Id")}</th>
                      <th>{t("Phone")}</th>
                      <th>{t("Job Title")}</th>
                      <th>{t("Training Room")}</th>
                      {activeTab === 2 && (
                        <>
                          <th>{t("Attended Days")}</th>
                          <th>{t("Attended Dates")}</th>
                        </>
                      )}

                      <th>
                        {(activeTab === 1 ||
                          activeTab === 3 ||
                          activeTab === 4) &&
                          t("Action")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {theoreticalParticipants?.map((item, index) => (
                      <tr key={index} className="cursor-pointer">
                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                        {/* <td>{item?.interview_schedule?.total_capacity}</td>
                                  <td>
                                    {item?.interview_schedule?.total_user_enrolled}
                                  </td>
                                  <td>
                                    {item?.interview_schedule?.total_available_seat}
                                  </td> */}
                        <td>{item?.user?.name}</td>
                        <td>{item?.user?.national_id}</td>
                        <td>
                          <p className="ltr fit_content">{item?.user?.phone}</p>
                        </td>
                        <td>{item?.job_details}</td>
                        <td>{item?.training_name}</td>
                        {activeTab === 2 && (
                          <>
                            <td>{item.attended_days}</td>
                            <td>{item.attended_dates?.dates?.join(",")}</td>
                          </>
                        )}

                        <td>
                          {activeTab === 1 && (
                            <div className="d-flex gap-3 ">
                              <Button
                                color="danger"
                                className="fit_content"
                                onClick={() => {
                                  setSelectedItem(item.uuid)
                                  setShowDeleteModal(true)
                                }}
                              >
                                <Trash size={16} />
                              </Button>
                            </div>
                          )}
                          {(activeTab === 3 || activeTab === 4) && (
                            <div className="d-flex gap-3 ">
                              <Button
                                color="primary"
                                className="fit_content"
                                onClick={() => {
                                  setSelectedItem(item.uuid)
                                  setModal1(true)
                                }}
                              >
                                {t("View Assessment")}
                              </Button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
          {!isLoading && theoreticalParticipants.length > 0 && (
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              totalCount={totalCount}
              onPageChange={onPageChange}
            />
          )}
        </div>
      )}
      <Modal
        isOpen={modal1}
        toggle={() => setModal1(false)}
        className="full_screen_modal"
        backdrop="static"
      >
        <ModalHeader toggle={() => setModal1(false)}>
          {t("View Assessment Details")}
        </ModalHeader>

        <ViewAssessment
          selectedItem={{ uuid: selectedItem }}
          toggle1={() => setModal1(false)}
          getAllData={getAllData}
        />
      </Modal>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => {
          setSelectedItem(null)
          setShowDeleteModal(false)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this participant?")}
      />
    </>
  )
}

export default CandidateTabs
